import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useAppointmentStore from "../../common/state/useAppointmentStore";
import { useAppointmentTime } from "../../zustand/useAppointmentStore";
import createDoctorAppointment from "../api/createDoctorAppointment";
import getDoctorAvailableDate from "../api/getDoctorAvailableDate";
import getDoctorAvailabilities from "../api/getDoctorAvailabilities";
import { format, lastDayOfMonth, startOfToday, subDays } from "date-fns";
import { fa } from "@faker-js/faker";

// import { useAppointmentStore } from '../../zustand/useAppointmentStore';

const MyComponent = () => {
  // Access values and setter from Zustand
  const { selectedDayAppointments, setSelectedDayAppointments } = useAppointmentStore();
  
  // Example: set appointments
  useEffect(() => {
    const appointments = [
      { id: 1, time: '10:00 AM' },
      { id: 2, time: '11:00 AM' },
    ];
    setSelectedDayAppointments(appointments);
  }, []);

  return (
    <div>
      <h2>Appointments for the day:</h2>
      <ul>
        {selectedDayAppointments.map((appointment) => (
          <li key={appointment.id}>{appointment.time}</li>
        ))}
      </ul>
    </div>
  );
};

const useSelectAppointmentDate = (props) => {
 
  // const { doctorData: doctorDataFromProps } = props;
   const { selectedDayAppointments:timeAvailable} = useAppointmentTime()
   const [avaiableTime, setAvailbleTime] = useState(null)
   useEffect(()=>{
setAvailbleTime(timeAvailable)
   }, [timeAvailable])
  //  console.log(timeAvailable, "timeAvailable")
 
  const navigate = useNavigate();
  const {
    doctorData,
    selectedMotive: motive,
    selectedAppointment,
    setSelectedAppointment
  } =
    useAppointmentStore(({ 
      doctorData,
      selectedMotive,
      selectedAppointment,
      setSelectedAppointment
    }) => ({
        doctorData,
        selectedMotive,
        setSelectedAppointment,
        selectedAppointment
      }));
 
  const [error, setError] = useState('');
  const [availableAppointments, setAvailableAppointments] = useState([]);
const selectedDayAppointments = useAppointmentStore((state) => state.setSelectedAppointment);
// console.log(selectedDayAppointments,"??")
  const [additionalInfo, setAdditionalInfo] = useState('');
  const [id, setId] = useState(null);
  const [isDoctorProfile, setIsDoctorProfile] = useState(false);
  const [isLoading, setIsLoading] = useState(false);


  const queryAppointmentHistory = async (startDate, endDate) => {
  
    
      const dates = await getDoctorAvailabilities({
        idDoctorUser: doctorData.id  ?doctorData.id : props?.doctorData?.id,
        idDoctorProfile: doctorData.idDoctorProfile  ? doctorData.idDoctorProfile : props?.doctorData?.idDoctorProfile,
        startDate,
        endDate,
        setError
      });
      if (dates) {
          setAvailableAppointments(dates);
      }
  };

  const onCloseErrorModal = () => setError('');
  const onCreateDoctorAppointment = async () => {
    // return
  setIsLoading(true);
  try {
    const payload = {
      idDoctor: doctorData.id,
      idAppointmentMotive: motive.id,
      ...(selectedAppointment?.id && { idAvailability: selectedAppointment.id }),
      appointmentDate: selectedAppointment?.date,
      userNotes: additionalInfo
    }; 
    // console.log(timeAvailable, selectedAppointment.appTime, "???")
    
    if (
  timeAvailable?.length > 0 &&
  (!selectedAppointment?.appTime || selectedAppointment.appTime === '')
){
      // console.log("inside")
        setError("Por favor, seleccione una hora para reservar una cita")
        setIsLoading(false)
        return false
    }
  // console.log(selectedAppointment, "selectedAppointment")
  //   return
    const response = await createDoctorAppointment(payload);    

    if (response?.idAppointmentStatus) {
      
      setIsLoading(false);
      navigate(
        `/${doctorData.id}/${doctorData.fullName?.replace(' ', '-')}/appointment-success`,
        { state: { appointmentId: response?.id } }
      );
      // selectedDayAppointments(null)
    }else if(response?.status == "waiting_listed"){
      setIsLoading(false);
      setError(response?.message)
      navigate(
        `/${doctorData.id}/${doctorData.fullName?.replace(' ', '-')}/appointment-success`,
        { state: { appointmentId: response?.id, message: response?.message } }
      );
    }else{
       setIsLoading(false);
      setError(response?.message[0] )
    }
  } catch (err) {
    setIsLoading(false);
    // Get message from API response if available, fallback otherwise
    const errorMessage =
      err?.response?.data?.message || 'Hubo un error creando la cita, por favor intente de nuevo';
    setError(errorMessage);
  }
};


  const onSetAdditionalInfo = (e) => setAdditionalInfo(e.target.value);
  
  useEffect(() => {

    // const now = new Date();
    // const tomorrow = new Date();
    // tomorrow.setDate(now.getDate() + 1);
    // const endDate = new Date(tomorrow.getFullYear(), tomorrow.getMonth() + 1, 0);
    // const endDate = new Date()
    // endDate.setDate(now.getDate() +2)
    let today = startOfToday();
    const startDate = format(subDays(new Date(today), 1), 'yyyy-MM-dd');
    const endDate = format(lastDayOfMonth(today), 'yyyy-MM-dd');
   
    queryAppointmentHistory(startDate, endDate);
  }, [props?.doctorData]);

  return {
    docData: doctorData,
    motive,
    setSelectedAppointment,
    availableAppointments,
    selectedAppointment,
    queryAppointmentHistory,
    error, 
    additionalInfo,
    onSetAdditionalInfo,
    onCreateDoctorAppointment,
    onCloseErrorModal,
    isLoading
  }
};

export default useSelectAppointmentDate;
